import { InfoItem } from "@/components/molecules";

export const AdjustmentsContent = ({ adjustmentsData }) => {
  const getVal = (v) => v !== undefined && v !== null ? v : '-';

  return (
    <>
      {/*Transactions -> Adjustments Details Section */}
      <div className="order-overview">
        <div className="grid grid-cols-3 gap-4 pb-6 pl-4">
          <InfoItem
            label="Adjustment Type"
            value={adjustmentsData?.adjustmentType}
          />
          <InfoItem label="Reason Code" value={getVal(adjustmentsData?.reasonCode)} />
          <InfoItem label="Quantity" value={getVal(adjustmentsData?.quantity)} />
        </div>
      </div>
    </>
  );
};
